import { api } from '@cwd/lib/main';
import { CurrentAccountReference } from '@shared/Root/Context.access';

export interface TimeZone {
    Name: string;
    TimeZoneId: string;
    Offset: number;
}

export async function get(): Promise<CurrentAccountReference> {
    return api.get('/Accounts/Current?account');
}

export async function update(property: string, value: any): Promise<CurrentAccountReference> {
    return api.post('/Accounts/Current/' + property, value);
}

export async function getTimeZones(): Promise<TimeZone[]> {
    return api.get('/TimeZones');
}

export async function getDefaultTimeZone(): Promise<string> {
    return api.get('/TimeZones/Default');
}
